import { useSelector } from "react-redux";

const url = process.env.REACT_APP_API_BASE_GEOSERVER;
function LeafletMap() {
  const { activeObjSchemes } = useSelector((state) => ({
    activeObjSchemes: state.obj.activeObj["asalSchemes"],
  }));
  return (
    <div>
      <iframe
        src={`${url}/get_schemes.php?schemed_id=${activeObjSchemes?.schId}`}
        width="100%"
        height="600px"
        style={{ border: "none" }}
        title="Dynamic Iframe"
      />
    </div>
  );
}

export default LeafletMap;
